const CASCADER_ROOT_TYPE = 'cascader';

/**
 * 三级平台级联时，叶子的 parent 是二级 Platform（Nintendo 等），不是 Data Source。
 * 输入框横杠前应始终展示数据源（GSD / NPD 等）。
 */
export const getCascaderDataSourceItem = (item?: any): any => {
  if (!item) {
    return item;
  }
  if (item.cascaderDataSourceLabelKey || item.cascaderDataSourceLabel) {
    return {
      ...(item.cascaderDataSource || {}),
      label: item.cascaderDataSourceLabel,
      labelKey: item.cascaderDataSourceLabelKey,
      value: item.cascaderDataSourceValue,
    };
  }
  if (item.cascaderDataSource) {
    return item.cascaderDataSource;
  }
  let current = item;
  while (current?.parent && current.parent.type !== CASCADER_ROOT_TYPE) {
    current = current.parent;
  }
  return current;
};
